{
  "title": "Passwort zurücksetzen",
  "subtitle": "Wähle ein sicheres Passwort",
  "newPasswordLabel": "Neues Passwort",
  "confirmPasswordLabel": "Passwort bestätigen",
  "resetButton": "Passwort zurücksetzen",
  "resettingButton": "Zurücksetzen...",
  "backToLogin": "Zurück zum Login",
  "requirementsText": "Mindestens 8 Zeichen mit Groß-, Kleinbuchstaben und Zahlen",
  "strengthLabel": "Stärke: {{strength}}",
  "passwordStrength": {
    "tooShort": "Zu kurz",
    "weak": "Schwach",
    "fair": "Okay",
    "good": "Gut",
    "strong": "Stark"
  },
  "invalidLink": {
    "title": "Ungültiger Reset-Link",
    "backButton": "Zurück zum Login"
  },
  "errors": {
    "tooShort": "Passwort muss mindestens 8 Zeichen haben",
    "needsUppercase": "Passwort muss mindestens einen Großbuchstaben enthalten",
    "needsLowercase": "Passwort muss mindestens einen Kleinbuchstaben enthalten",
    "needsNumber": "Passwort muss mindestens eine Zahl enthalten",
    "noMatch": "Passwörter stimmen nicht überein",
    "invalidOrExpired": "Ungültiger oder abgelaufener Link. Bitte fordere einen neuen an.",
    "genericError": "Ein Fehler ist aufgetreten. Bitte versuche es erneut."
  }
}
